module.exports = __webpack_public_path__ + "static/media/deal.590f94ba.png";